(() => {
  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.yeswinSettings?.currency||'USD'}).format(cents/100)}catch(e){return (cents/100).toFixed(2)}};

  function initRoot(root){
    if(!root || root.dataset.ywProductInitialized==='true') return;
    const json=root.querySelector('[data-product-json]');
    if(!json) return;
    let variants=[];
    try{variants=JSON.parse(json.textContent)}catch(e){return}
    root.dataset.ywProductInitialized='true';
    const radios=[...root.querySelectorAll('[data-option-input]')];
    const forms=[...root.querySelectorAll('form[action*="/cart/add"]')];
    function selectedMap(){const groups={};radios.forEach(r=>{if(r.checked)groups[Number(r.dataset.optionPosition)]=r.value});return groups}
    function selected(){const groups=selectedMap();return Object.keys(groups).sort((a,b)=>a-b).map(k=>groups[k])}
    function findVariant(){const opts=selected();return variants.find(v=>v.options.every((o,i)=>o===opts[i]))}
    function updateOptionAvailability(){
      const chosen=selectedMap();
      radios.forEach(r=>{
        const pos=Number(r.dataset.optionPosition)-1;
        const possible=variants.some(v=>v.available&&v.options[pos]===r.value&&v.options.every((o,i)=>i===pos||!chosen[i+1]||chosen[i+1]===o));
        r.disabled=!possible&&!r.checked;
      });
      root.querySelectorAll('[data-option-group]').forEach(group=>{const checked=group.querySelector('input:checked');const label=group.querySelector('[data-selected-option]');if(label&&checked)label.textContent=checked.value});
    }
    function update(){
      const v=findVariant();
      root.dataset.variantId=v?.id||'';
      forms.forEach(f=>{
        const i=f.querySelector('input[name="id"]'); if(i)i.value=v?.id||'';
        const b=f.querySelector('button[type="submit"]');
        if(b){b.disabled=!v?.available;b.textContent=!v?'Unavailable':v.available?'Add to cart':'Sold out'}
      });
      root.querySelectorAll('[data-product-price]').forEach(el=>el.textContent=v?money(v.price):'');
      root.querySelectorAll('[data-product-compare]').forEach(el=>{if(v&&v.compare_at_price>v.price){el.textContent=money(v.compare_at_price);el.hidden=false}else{el.hidden=true}});
      root.querySelectorAll('[data-product-availability]').forEach(el=>el.textContent=!v?'Unavailable':v.available?'In stock':'Sold out');
      if(v?.featured_media?.id){root.querySelector(`[data-media-thumb="${v.featured_media.id}"]`)?.click()}
      const stickyId=root.querySelector('[data-sticky-variant]'); if(stickyId) stickyId.value=v?.id||'';
      updateOptionAvailability();
    }
    radios.forEach(r=>r.addEventListener('change',update)); update();
    root.querySelectorAll('[data-qty-minus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(1,Number(i.value||1)-1);i.dispatchEvent(new Event('change',{bubbles:true}))}));
    root.querySelectorAll('[data-qty-plus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=Math.min(Number(i.max||999),Number(i.value||1)+1);i.dispatchEvent(new Event('change',{bubbles:true}))}));
    const mainQty=root.querySelector('[data-main-quantity]'); if(mainQty)mainQty.addEventListener('change',()=>root.querySelectorAll('[data-sticky-quantity]').forEach(i=>i.value=mainQty.value));
  }

  document.querySelectorAll('[data-product-root]').forEach(initRoot);
  window.YeswinProduct={init:initRoot};

  document.querySelectorAll('product-recommendations[data-url]').forEach(async el=>{try{const html=await fetch(el.dataset.url).then(r=>r.text());const doc=new DOMParser().parseFromString(html,'text/html');const incoming=doc.querySelector('product-recommendations [data-recommendations-container]');const current=el.querySelector('[data-recommendations-container]');if(incoming&&current)current.innerHTML=incoming.innerHTML}catch(e){}});
})();
